<template>
  <v-autocomplete
    :items="industries"
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
  </v-autocomplete>
</template>

<script>
  export default {
    props: [
      'value'
    ],
    computed: {
      industries() {
        return this.$store.getters.industries
          .map(el => ({ value: el.code, text: el.title }))
          .sort((a, b) => {
            var nameA = a.text.toLowerCase()
            var nameB = b.text.toLowerCase()

            if (nameA < nameB) {
              return -1
            }
            if (nameA > nameB) {
              return 1
            }

            return 0
          })
      }
    }
  }
</script>